import 'core-js/stable'
import Vue from 'vue'
import axios from 'axios'
import CoreuiVuePro from '@coreui/vue-pro'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from "@/store/store";
import { installManualI18n } from '@/i18n/install'
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);

// Global axios interceptor to attach Bearer token for all API requests
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token && !config.headers["Authorization"]) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

installManualI18n()

Vue.use(CoreuiVuePro)
Vue.prototype.$log = console.log.bind(console)
import moment from 'moment'
Vue.prototype.moment = moment

store.dispatch("user/loadStoredUser").then(() => {
  new Vue({
    el: '#app',
    router,
    store,
    icons,
    template: '<App/>',
    components: {
      App
    }
  }).$mount('#app')
});
